// @flow @format
import Select from './Select';

import 'react-select/dist/react-select.css';
import 'react-virtualized/styles.css';
import 'react-virtualized-select/styles.css';

import './Select.css';

export default Select;



// WEBPACK FOOTER //
// ./src/components/Select/index.js